import Vue from 'vue'
// import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import { localize } from 'vee-validate'
import ptBR from 'vee-validate/dist/locale/pt_BR.json'

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

import VueTheMask from 'vue-the-mask'
import VueApexCharts from 'vue-apexcharts'
import money from 'v-money'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Hotjar from 'vue-hotjar'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'

import './libs/FormComponents'
import './libs/Search'
import './libs/users'
import './libs/fontawesome'
import './libs/actions/deleteAction'
import './components/i2/notification/toast'
import './registerServiceWorker'
import './libs/filters/DocumentFilter'
import Validation from './libs/validation'
// Global registration

import './filters/CurrencyFilter'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Validation)
Vue.use(VueApexCharts)
Vue.use(Hotjar, {
  id: '3002525',
  isProduction: process.env.NODE_ENV === 'production',
})
Vue.component('apexchart', VueApexCharts)
Vue.use(money, {
  precision: 2,
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: ' #',
  masked: true,
})
Vue.use(VueTheMask)
// BSV Plugin Registration

Vue.use(VueMoment)
moment.defaultFormat = {
  pt_BR: 'DD/MM/YYYY',
}
moment.locale('pt_BR')
Vue.use(VueMoment, { moment })

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false
localize('pt_BR', ptBR)
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
Vue.config.dateFormat = moment.defaultFormat
